// Company domains are stored without a scheme (e.g. "acme.eflogistics.io");
// shareable links need one so they open as links in messages and browsers.
export const withHttps = (domain) => {
  const value = (domain || "").trim().replace(/\/+$/, "");
  if (!value) return "";
  return /^https?:\/\//i.test(value) ? value : "https://" + value;
};
